import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface StatusChipProps {
  text: string;
  color: "success" | "warning" | "error";
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block",
    transform: "translate(0px,-50%)",
  },
  chip: {
    padding: "12px 16px",
    borderRadius: "8px",
    backgroundColor: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "48px",
  },
  text: {
    fontWeight: 700,
    fontSize: "1.1250em",
    lineHeight: "1.1250em",
  },
  success: {
    border: "2px solid #477213",
    color: "#477213",
    backgroundColor: "#E5F7CF",
  },
  warning: {
    border: "2px solid #9A3B04",
    color: "#9A3B04",
    backgroundColor: "#FEDFCD",
  },
  error: {},
}));

export const StatusChip = (props: StatusChipProps) => {
  const { text, color } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={`${classes.chip} ${classes[color]}`}>
        <Typography
          lineHeight="18px"
          fontWeight={700}
          fontSize={18}
          className={classes.text}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};
